﻿import { Config, ErrorHandling, HtmlContentEditor } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { getLanguageList } from "./Helpers/LanguageList";
import "./Navigation/LanguageSelector"; // This will auto-initialize

Config.rootNamespaces.push('dsTrade');
// TranslationConfig.getLanguageList = getLanguageList; // This might not be available in this version
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
gridDefaults.useCssVars = false;

// Find jQuery if available
declare var $: any;
if (typeof $ !== 'undefined' && $?.fn?.colorbox) {
    $.fn.colorbox.settings.maxWidth = "95%";
    $.fn.colorbox.settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;
// window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler); // This might not be available